import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, AngularFireDatabaseModule} from 'angularfire2/database';
import swal from 'sweetalert';
import {Router} from '@angular/router';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  username='';
  password='';
  password2='';
  tel='';

  constructor(
    private router: Router,
    public db:AngularFireDatabase ,
    private fire: AngularFireAuth) { }

  ngOnInit() {
  }

  registerUser(){
    if(this.username == '' || this.password == '' || this.password2 == '' || this.tel == ''){
        this.alert('กรุณาป้อนข้อมูลให้ครบถ้วนด้วยคะ')
    }else{

      if((this.username).length >= 6){
        if(this.password == this.password2  ){
          console.log('เท่านะครับ')
        
        this.fire.auth.createUserWithEmailAndPassword(this.username +'@domian.xta',this.password)
        .then((data)=>{
    
                this.db.list('user').push({
                uid : data.user.uid,
                username: (this.username+'@domian.xta').toLowerCase(),
                password:this.password,
                tel:this.tel,
              })
              this.adduser(data.user.uid,this.username+'@domian.xta',this.password,this.tel,);
    
         
          // console.log("แล้วละเน้อ") 
          // this.add_realtime_usesell;
          console.log('got data',data);
          this.alert('สามารถล็อนอินเข้าสู่ระบบได้เลยคะ')
          this.router.navigateByUrl('/login');
        }
        )
        .catch(error =>{
          console.log('got an error', error.message);
            if(error.message == "The email address is badly formatted."){
              console.log('eieie');
              this.alert('ชื่อผู้ใช้งาน กรุณาป้อนตัวอักษร A-Z,a-z,0-9 หรือ _')
            }
            if(error.message == "Password should be at least 6 characters"){
              this.alert('กรุณาป้อน รหัสผ่าน ให้ครบ 6 ตัวอักษร')
            }
            if(error.message == "The email address is already in use by another account."){
              this.alert('ผู้ใช้นี้มีคนอื่นใช้แล้ว กรุณาเปลี่ยนใหม่')
            }
        });
        console.log('Would register user with',this.username,this.password);
      }else{
        alert('รหัสผ่านไม่เหมือนกัน กรุณาป้อนให้ถูกต้อง')
      }

      }else{
        alert('กรุณาป้อน Username ให้ครบ 6 ตัวอักษร')
      }
    }
  }

  adduser(uid , email,password,tel){
    var email_lower = email.toLowerCase()
    let data ={
      uid : uid ,
      username : email_lower ,
      password:password,
      tel:tel,
      // category_user_select : 'null',
    }
    // this.db.object('user/'+uid).update(data);
    this.db.object('userbacara/'+uid).update(data);
  }

  alert_confirm(){

      swal({
        title: "คุณต้องการเพิ่มประเภทขยะรีไซเคิล?",
        text: "ใช่หรือไม่",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          swal("การเพิ่มข้อมูลประเภทขยะรีไซเคิลสำเร็จ", {
            icon: "success",
          });
          console.log('save')   
        } else {
          swal("การเเพิ่มข้อมูลประเภทขยะรีไซเคิลไม่สำเร็จ!");
        }
      });
      //  alert('กรุณาป้อนข้อมูล')

  }
  alert(message){
    swal("แจ้งเตือน!", message);
  }

  

}
